import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages - Main
import HomePage from './pages/HomePage';

// Pages - Formations
import FormationsPage from './pages/FormationsPage';
import FormationDetailPage from './pages/FormationDetailPage';

// Pages - Articles
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';

// Pages - Authentication
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

// Pages - User Dashboard
import DashboardPage from './pages/DashboardPage';
import CoursPage from './pages/CoursPage';

// Pages - Payment
import PaymentPage from './pages/PaymentPage';

// Pages - Sessions & Visio
import SessionsPage from './pages/SessionsPage';
import VirtualClassroomPage from './pages/VirtualClassroomPage';

// Styles
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />

          <main className="main-content">
            <Routes>
              {/* ========== HOME ========== */}
              <Route path="/" element={<HomePage />} />

              {/* ========== FORMATIONS ========== */}
              <Route path="/formations" element={<FormationsPage />} />
              <Route path="/formations/:id" element={<FormationDetailPage />} />

              {/* ========== ARTICLES ========== */}
              <Route path="/articles" element={<ArticlesPage />} />
              <Route path="/article/:id" element={<ArticleDetailPage />} />

              {/* ========== AUTHENTICATION ========== */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              {/* ========== USER DASHBOARD ========== */}
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/cours/:id" element={<CoursPage />} />

              {/* ========== PAYMENT ========== */}
              <Route path="/payment/:id" element={<PaymentPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />

              {/* ========== SESSIONS & VISIO ========== */}
              <Route path="/sessions" element={<SessionsPage />} />
              <Route path="/classroom/:sessionId" element={<VirtualClassroomPage />} />

              {/* ========== 404 ========== */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

/**
 * Payment Success Page
 */
function PaymentSuccessPage() {
  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px'
    }}>
      <div style={{
        background: 'white',
        padding: '50px 40px',
        borderRadius: '24px',
        textAlign: 'center',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px'
      }}>
        <div style={{ fontSize: '80px', marginBottom: '20px' }}>✅</div>
        <h1 style={{ fontSize: '32px', color: '#2d3748', marginBottom: '15px' }}>
          Paiement confirmé !
        </h1>
        <p style={{ fontSize: '16px', color: '#718096', marginBottom: '30px' }}>
          Votre paiement a été validé avec succès. Vous avez maintenant accès à votre formation.
        </p>
        <button
          onClick={() => window.location.href = '/dashboard'}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            padding: '14px 32px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          Aller au Dashboard
        </button>
      </div>
    </div>
  );
}

/**
 * 404 Not Found Page
 */
function NotFoundPage() {
  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <div style={{ fontSize: '120px', marginBottom: '20px', fontWeight: 'bold', color: '#667eea' }}>
        404
      </div>
      <h1 style={{ fontSize: '36px', color: '#2d3748', marginBottom: '15px' }}>
        Page non trouvée
      </h1>
      <p style={{ fontSize: '18px', color: '#718096', marginBottom: '30px', maxWidth: '500px' }}>
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <button
        onClick={() => window.location.href = '/'}
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          border: 'none',
          padding: '14px 32px',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.3s'
        }}
        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
      >
        Retour à l'accueil
      </button>
    </div>
  );
}

export default App;